import * as React from "react";
import { SVGProps } from "react";

const SvgWallet = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 187 138"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#Wallet_svg__a)">
      <path
        d="M125.53 86.35a9.46 9.46 0 0 0 9.46-9.46 9.46 9.46 0 1 0-9.46 9.46Z"
        fill="#051513"
      />
      <path
        d="M174.14 51.43V29a13 13 0 0 0-13-13H13A13 13 0 0 0 0 29v95.77a12.999 12.999 0 0 0 13 13h148.14a13 13 0 0 0 13-13v-22.42a12.999 12.999 0 0 0 12.3-13v-25a13.002 13.002 0 0 0-12.3-12.92Zm-13 78.34H13a5.002 5.002 0 0 1-5-5V29a5 5 0 0 1 5-5h148.14a5.002 5.002 0 0 1 5 5v22.39h-53.08a12.999 12.999 0 0 0-13 13v25a13 13 0 0 0 13 13h53.08v22.39a5.003 5.003 0 0 1-5 4.99Zm17.3-40.39a5.002 5.002 0 0 1-5 5h-60.38a5.002 5.002 0 0 1-5-5v-25a5.002 5.002 0 0 1 5-5h60.38a5.002 5.002 0 0 1 5 5v25Z"
        fill="#051513"
      />
      <path
        d="M.06 27.77A13 13 0 0 1 13 16h135.001V9a9 9 0 0 0-9-9H9.051a9 9 0 0 0-9 9v18.78l.01-.01Z"
        fill="#00D37E"
      />
    </g>
    <defs>
      <clipPath id="Wallet_svg__a">
        <path fill="#fff" d="M0 0h186.44v137.77H0z" />
      </clipPath>
    </defs>
  </svg>
);

export default SvgWallet;
